import { Midnight } from "./colours"

/**
 * - Styles override to MuiToggleButton to match Vacasa owner onboarding design
 */
const muiToggleButtonGroup = {
    styleOverrides: {
        root: () => ({
            background: Midnight[4],
            height: "40px",
            borderRadius: "50px"
        }),
    },
}

export default muiToggleButtonGroup
